interface REQ_A_CALL_ERR {
  name: string | undefined;
  email: string | undefined;
  phn: string | undefined;
  city: string | undefined;
  cpNm: string | undefined;
}

interface REQ_A_CALL {
  name: string;
  email: string;
  phn: string;
  city: any;
  state: string;
  cpNm: string;
}

export const ReqACallForm: REQ_A_CALL = {
  name: "",
  email: "",
  phn: "",
  city: "",
  state: "",
  cpNm: "",
};
export const ReqACallFormErr: REQ_A_CALL_ERR = {
  name: undefined,
  email: undefined,
  phn: undefined,
  city: undefined,
  cpNm: undefined,
};

export interface SIGNUP_FORM {
  email: string;
  password: string;
  confirmPassword: string;
}
